import type { GetContentModulesResponse, SetupProgress } from '@/services/api/api.types'
import { isSetupProgressEmpty } from '@/services/api/api.types'

/**
 * Setup progress service - now simplified for manual completion only
 * All setup steps are completed manually through user actions, not automatic state checking
 */

export interface GrandfatheringData {
  contentModules?: GetContentModulesResponse
}

/**
 * Check if sponsor should be grandfathered (existing sponsor with empty setup progress but has content)
 *
 * Criteria:
 * 1. Setup progress is currently empty (all steps are false)
 * 2. They have content modules where isVisibleToMSK is false (sponsor-specific content)
 */
export function shouldGrandfatherSponsor(data: GrandfatheringData, currentProgress: SetupProgress): boolean {
  // If setup progress is not empty (has some steps completed), don't grandfather
  if (!isSetupProgressEmpty(currentProgress)) {
    return false
  }

  // Check if they have sponsor-specific content modules (visibleToMsk: false)
  const sponsorSpecificModules =
    data.contentModules?.filter(cm => cm.visibleToMsk === false && cm.status !== 'removed').length ?? 0

  return sponsorSpecificModules > 0
}

/**
 * Get completed setup progress for grandfathered sponsors
 * Returns all steps as completed
 */
export function getGrandfatheredProgress(): SetupProgress {
  return {
    defineTopics: true,
    draftWelcomeMessage: true,
    inviteExperts: true,
    createContent: true,
    inviteUsers: true,
  }
}
